const PRODUCT_VERSION = '1.5.5-2';

const VALUES_CONFIG = {
  production: true,

  defaultPermissions: 'allow all',
  jiraToken: 'ODIzNzcyOTg5MTIxOqNzhZ92yqKqt8d4fXZwi015HlnI',
  testplan: 'TIME-2673'
};

const VALUES_PRODUCT = {
  applicationName: 'TI-Messenger Pro Client',
  timClientVersion: `tim-client-v${PRODUCT_VERSION}`,

  // Produktinformationen:
  productId: '1',
  productType: 'TI-M',
  productTypeVersion: 'gemProdT_TI-M_Client_Pro_PTV_1.0.2-1_V1.0.0',
  producerId: 'BITMA',
  productShortname: 'TIME',
  productVersion: PRODUCT_VERSION,
  producerName: 'Bitmarck GmbH',
  productName: 'TI-Messenger Pro Client'
};

export const environment = {
  ...VALUES_CONFIG,
  ...VALUES_PRODUCT
};
